import { Route, Switch, useRouteMatch } from 'react-router-dom';
import UARScaffold from './hoc/Scaffold';
import { UAR_CONSTANTS } from './util/constants';

const UserAccessReview = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<Route
				path={`${path}/Dashboard`}
				exact
				render={props => (
					<UARScaffold
						key={UAR_CONSTANTS.PAGE_DASHBOARD}
						pageID={UAR_CONSTANTS.PAGE_DASHBOARD}
						{...props}
					/>
				)}
			/>
			<Route
				path={`${path}/AccountDetails`}
				exact
				render={props => (
					<UARScaffold
						key={UAR_CONSTANTS.PAGE_ACCOUNT_DETAILS}
						pageID={UAR_CONSTANTS.PAGE_ACCOUNT_DETAILS}
						{...props}
					/>
				)}
			/>
			<Route
				path={`${path}/Delegate`}
				exact
				render={props => (
					<UARScaffold
						key={UAR_CONSTANTS.PAGE_DELEGATE}
						pageID={UAR_CONSTANTS.PAGE_DELEGATE}
						{...props}
					/>
				)}
			/>
			<Route
				path={`${path}/OrgChart`}
				exact
				render={props => (
					<UARScaffold
						key={UAR_CONSTANTS.PAGE_ORG_CHART}
						pageID={UAR_CONSTANTS.PAGE_ORG_CHART}
						{...props}
					/>
				)}
			/>
			<Route
				path={`${path}/Reassign`}
				exact
				render={props => (
					<UARScaffold
						key={UAR_CONSTANTS.PAGE_REASSIGN}
						pageID={UAR_CONSTANTS.PAGE_REASSIGN}
						{...props}
					/>
				)}
			/>
			<Route
				path={`${path}/Renew`}
				exact
				render={props => (
					<UARScaffold
						pageID={UAR_CONSTANTS.PAGE_RENEW}
						key={UAR_CONSTANTS.PAGE_RENEW}
						{...props}
					/>
				)}
			/>
			<Route
				path={`${path}/Terminate`}
				exact
				render={props => (
					<UARScaffold
						key={UAR_CONSTANTS.PAGE_TERMINATE}
						pageID={UAR_CONSTANTS.PAGE_TERMINATE}
						{...props}
					/>
				)}
			/>
			<Route
				path={`${path}/UpdateProfile`}
				exact
				render={props => (
					<UARScaffold
						key={UAR_CONSTANTS.PAGE_UPDATE_PROFILE}
						pageID={UAR_CONSTANTS.PAGE_UPDATE_PROFILE}
						{...props}
					/>
				)}
			/>
			<Route
				path={`${path}/ReviewEmployeeAccess`}
				exact
				render={props => (
					<UARScaffold
						key={UAR_CONSTANTS.PAGE_REVIEW_EMPLOYEE_ACCESS}
						pageID={UAR_CONSTANTS.PAGE_REVIEW_EMPLOYEE_ACCESS}
						{...props}
					/>
				)}
			/>
			<Route
				path={`${path}/Validate`}
				exact
				render={props => (
					<UARScaffold
						key={UAR_CONSTANTS.PAGE_VALIDATE}
						pageID={UAR_CONSTANTS.PAGE_VALIDATE}
						{...props}
					/>
				)}
			/>
			<Route path='*'>404...</Route>
		</Switch>
	);
};
export default UserAccessReview;
